import {State} from '../types/state'

export const isCurrentUserLoggedIn = (state: State) => state.currentUser.loggedIn
